var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"soprts_in_acc_2",staticStyle:{"width":"25%"}},[_c('div',{staticClass:"sports_v_l_1"},[_vm._v(" "+_vm._s(_vm.bets.name === 'AnyOther' ? '기타' : _vm.bets.name)+" ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sports_v_r_1"},[_c('img',{staticStyle:{"width":"9px"},attrs:{"src":require("@/assets/img/ico/ico_secret.png")}})])
}]

export { render, staticRenderFns }